import { Subject } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ChangeDetectorRef, Directive, OnDestroy } from '@angular/core';
import { ApiService } from '@shared/apis';
import { FormBuilder } from '@angular/forms';
import { SpinnerService } from '@shared/services/spinner.service';
import { GooglePlacesAutocompleteService } from '@shared/services/google-places-autocomplete.service';
import { AuthService } from '@core/auth/auth.service';
import { takeWhile } from 'rxjs/operators';
import { Router } from '@angular/router';
import { BpService } from '@shared/services/bp.service';
import { FileService } from '@shared/services/file.service';
import { CaseService } from '@routes/b2b/cases/shared/case.service';
import { RsmEscalationService } from '@routes/b2b/rsm-escalations/shared/rsm-escalation.service';
import { GooglePlacesAutocompleteCpService } from '@shared/services/google-places-autocomplete-cp.service';

@Directive()
export class DialogBase implements OnDestroy {
  public onClose: Subject<any> = new Subject();
  // subclasses unsubscribe on the same flag rather than tracking their own
  protected alive = true;

  constructor(protected bsModalRef: BsModalRef,
              protected fb: FormBuilder,
              protected spinnerService: SpinnerService,
              protected authService: AuthService,
              protected modalService: BsModalService,
              protected googlePlacesAutocomplete: GooglePlacesAutocompleteService,
              protected googlePlacesAutocompleteCp: GooglePlacesAutocompleteCpService,
              protected apiService: ApiService,
              protected router: Router,
              protected bpService: BpService,
              protected caseService: CaseService,
              protected rsmEscalationService: RsmEscalationService,
              public fileService: FileService,
              public cdr: ChangeDetectorRef,
  ) {
    this.doInit();
  }

  doInit() {
    this.authService.token$
      .pipe(takeWhile(() => this.alive))
      .subscribe(res => {
        if (!res) {
          this.bsModalRef.hide();
        }
      });
  }

  close() {
    this.onClose.next(null);
    this.bsModalRef.hide();
  }

  cancel() {
    this.bsModalRef.hide();
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
